
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.347 23.883a3.212 3.212 0 01-2.286-.946 3.237 3.237 0 010-4.572l10.02-10.016a6.54 6.54 0 01.557-4.861A6.462 6.462 0 0115.513.366 6.556 6.556 0 0117.353.1c1.077 0 2.152.276 3.108.799a.751.751 0 01.171 1.188l-3.096 3.097v1.277h1.278l3.116-3.114a.739.739 0 01.62-.195.754.754 0 01.551.383 6.502 6.502 0 01.41 5.323 6.525 6.525 0 01-6.122 4.296c-.587 0-1.171-.08-1.738-.239L5.633 22.937c-.61.61-1.422.946-2.286.946zM17.352 1.6c-.476 0-.952.069-1.416.205a4.965 4.965 0 00-2.981 2.402 5.004 5.004 0 00-.315 4.095.755.755 0 01-.175.785L2.121 19.426a1.736 1.736 0 000 2.451 1.72 1.72 0 001.225.507c.464 0 .899-.18 1.225-.507l10.34-10.344a.744.744 0 01.784-.175 4.96 4.96 0 001.693.297 5.019 5.019 0 004.71-3.305 4.983 4.983 0 00.085-3.137l-2.53 2.53a.755.755 0 01-.53.22h-2.338a.75.75 0 01-.75-.75V4.874c0-.2.078-.389.22-.53l2.53-2.531a4.881 4.881 0 00-1.433-.213z"}})])
          )
        }
      }
    